import React, { useEffect, useState, useRef } from "react";
import { useTranslation } from 'react-i18next';
import {
    Row,
    Col,
    Select,
    Form,
    Button,
    Modal
} from '../../ui/ot'
import SerialReceiveForm from "./serial_receive_form";
import { Plus, X, Settings2 } from 'lucide-react';

const SerialReceiveModal = ({
    keyPrefix = "cataloging.serial_receive",
    axiosMode = "post",
    propsForm,
    propsOpen = null,
    propsLoading = null,
    openButtonText = "",
    onFinish = () => { },
    propsSetOpen = () => { },
    propsSetLoading = () => { },
}) => {
    const { t } = useTranslation('translation', { keyPrefix: keyPrefix })
    const [form_] = Form.useForm();
    const form = propsForm ? propsForm : form_
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const showModal = () => {
        if (propsOpen === null) {
            setIsModalOpen(true);
        } else {
            propsSetOpen(true);
        }
    };
    const closeModal = () => {
        if (propsOpen === null) {
            setIsModalOpen(false);
        } else {
            propsSetOpen(false);
        }
        if (propsLoading === null) {
            setLoading(false);
        } else {
            propsSetLoading(false);
        }
    };

    const handleOk = () => {
        if (propsLoading === null) {
            setLoading(true);
        } else {
            propsSetLoading(true);
        }
        form.submit();
    };

    const handleCancel = () => {
        closeModal();
    };
    const onFormFinish = (values) => {
        onFinish(values);
    };

    return (
        <Row>
            <Col>
                {propsOpen === null && (
                    <Button type="primary" onClick={showModal}>
                         新增
                    </Button>
                )}
            </Col>
            <Col>
                <Modal
                    title={`${openButtonText}`}
                    open={propsOpen === null ? isModalOpen : propsOpen}
                    onOk={handleOk}
                    onCancel={handleCancel}
                    confirmLoading={false}
                    maskClosable={false}
                    width={1800}
                    contentStyle={{
                        padding: 16,
                    }}
                    okText={'儲存'}
                    cancelText={'取消'}
                >
                    <Row>
                        <Col span={24}>
                            <SerialReceiveForm
                                open={propsOpen === null ? isModalOpen : propsOpen}
                                axiosMode={axiosMode}
                                propsForm={form}
                                onFormFinish={onFormFinish}
                            />
                        </Col>
                    </Row>
                </Modal>
            </Col>
        </Row>
    );
}
export default SerialReceiveModal